import { CollapsibleCard, OtoButtons } from 'app/components/common';
import i18next from 'i18next';
import React, { useMemo } from 'react';
import { ISavedReservation } from 'types';
import { downloadReservationsCSV } from 'utils/csv';

export const ReservationsMarketingAgreementStatistics: React.FC<{
  reservations: ISavedReservation[];
}> = ({ reservations }) => {
  const {
    reservationsWithBothAgreements,
    reservationsWithEmailAgreement,
    reservationsWithSmsAgreement,
    uniqueEmailsWithMarketingAgreement,
    uniquePhoneNumbersWithMarketingAgreement,
  } = useMemo(() => {
    const reservationsWithSmsAgreement = reservations
      .filter((reservation) => reservation.sms_marketing)
      .map((reservation) => ({
        ...reservation,
        email: '-',
      }));
    const reservationsWithEmailAgreement = reservations
      .filter((reservation) => reservation.email_marketing)
      .map((reservation) => ({
        ...reservation,
        phone_number: '-',
      }));
    const reservationsWithBothAgreements = reservations.filter(
      (reservation) => reservation.sms_marketing && reservation.email_marketing
    );

    const uniquePhoneNumbersWithMarketingAgreement: string[] = [
      ...new Set(
        reservationsWithSmsAgreement.map(
          (reservation) => reservation.phone_number
        )
      ),
    ];

    const uniqueEmailsWithMarketingAgreement: string[] = [
      ...new Set(
        reservationsWithEmailAgreement
          .map((reservation) => reservation.email)
          .filter(Boolean) as string[]
      ),
    ];

    return {
      reservationsWithBothAgreements,
      reservationsWithSmsAgreement,
      reservationsWithEmailAgreement,
      uniqueEmailsWithMarketingAgreement,
      uniquePhoneNumbersWithMarketingAgreement,
    };
  }, [reservations]);
  return (
    <CollapsibleCard
      buttonClassName={'p-1'}
      className={'my-2 mw-600'}
      title={i18next.t('reservations-marketing-agreement-statistics.title')}
    >
      <div>
        {i18next.t('reservations-marketing-agreement-statistics.sms-count', {
          count: reservationsWithSmsAgreement.length,
          uniqueCount: uniquePhoneNumbersWithMarketingAgreement.length,
        })}
      </div>
      <OtoButtons.DownloadButton
        onClick={() =>
          downloadReservationsCSV(
            reservationsWithSmsAgreement,
            'rezerwacje-ze-zgodami-sms.csv'
          )
        }
      >
        {i18next.t('reservations-marketing-agreement-statistics.download-csv')}
      </OtoButtons.DownloadButton>

      <hr />

      <div>
        {i18next.t('reservations-marketing-agreement-statistics.email-count', {
          count: reservationsWithEmailAgreement.length,
          uniqueCount: uniqueEmailsWithMarketingAgreement.length,
        })}
      </div>
      <OtoButtons.DownloadButton
        onClick={() =>
          downloadReservationsCSV(
            reservationsWithEmailAgreement,
            'rezerwacje-ze-zgodami-email.csv'
          )
        }
      >
        {i18next.t('reservations-marketing-agreement-statistics.download-csv')}
      </OtoButtons.DownloadButton>

      <hr />

      <div>
        {i18next.t('reservations-marketing-agreement-statistics.both-count', {
          count: reservationsWithBothAgreements.length,
        })}
      </div>
      <OtoButtons.DownloadButton
        onClick={() =>
          downloadReservationsCSV(
            reservationsWithBothAgreements,
            'rezerwacje-z-obu-zgodami.csv'
          )
        }
      >
        {i18next.t('reservations-marketing-agreement-statistics.download-csv')}
      </OtoButtons.DownloadButton>
    </CollapsibleCard>
  );
};

export default ReservationsMarketingAgreementStatistics;
